import type { PostKidsSelectRequest, PostKidsSelectResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const postKidsSelect = sendRequest<PostKidsSelectRequest, PostKidsSelectResponse>({
  url: '/kids/select',
  method: 'post',
});
